import { Injectable } from '@angular/core';
import { HttpFunctionsService } from '../http-services/http-functions.service';
import { CommonService } from '../Common-function/common.service';
import { catchError, map, Observable, throwError } from 'rxjs';

interface Campaign {
  _id: string;
  name: string;
  status: string;
  startAt: string;
  endAt?: string;          // optional — "briyani" and "butter_chicken" don't have it
  dailyBudget: number;
  spentToday: number;
  totalSpent: number;
  beatsCount: number
}

interface producerAnalyticsKpiModel {
  impressions: number,
  clicks: number,
  plays: number,
  purchases: number,
  spend: number,
  revenue: number,
  ctr: number,
  conversionRate: number,
  roi: number
  date?: any
  reach?: any
  addToCart?: any
  checkouts?: any
}           

type CombinedCampaign = Campaign & producerAnalyticsKpiModel;

export interface finalProdcuerAnalyticsResponse {
  campaignList: Array<CombinedCampaign>;
  activeCampaigns: number
  totalCampaigns: number
  totals: producerAnalyticsKpiModel
  daily: Array<producerAnalyticsKpiModel>
}

@Injectable({
  providedIn: 'root'
})
export class CampaignService {
  baseUrl: string = 'ads/';
  dashBoardUrl: string = 'analytics/';
  currentCurrentBalance: number = 0;
  constructor(private httpService: HttpFunctionsService,
      private commonService: CommonService) { }
  
  getWalletBalance(type: string = "",isShowLoader: boolean = true) {
    return this.httpService.getMethod(this.baseUrl + 'wallet', isShowLoader).pipe(map((response: any) => {
      let finalData: any = "";
      if (response && response.data) {
        finalData = type === "fullDetails" ? response?.data : response.data.balance;
      }
      return finalData;
    }));
  }

  addFundsToWallet(data: any, isShowLoader: boolean = true) {
    return this.httpService.postMethod(this.baseUrl + 'wallet/topup', data, isShowLoader);
  }

  createCampaign(data: any, isShowLoader: boolean = true) {
    return this.httpService.postMethod(this.baseUrl +'create-campaigns' , data, isShowLoader);
  }

  getCampaign(data: any, isShowLoader: boolean = true): Observable<[]> {
    return this.httpService.getMethod(`${this.baseUrl}list-campaigns?page=${data.page}&limit=${data.limit}`, isShowLoader).pipe(map((res: any) => {
        let sendData: any = [];
      if (res && res.data) {
        sendData = res.data;
        sendData = sendData.filter((compObj: any) => {
           switch(compObj.status) {
            case 'draft' :
              compObj['delivery_status'] = {
                "id": "draft",
                "label": "Draft",
                 "disabled": true 
              };
            break;
            case 'pending_payment' :
              compObj['delivery_status'] = {
                "id": "payment_pending",
                "label": "payment pending",
                 "disabled": true
              };
            break;
            case 'active' :
              compObj['delivery_status'] = {
                    "id": "running",
                    "label": "Running",
                     "disabled": false
                  };
            break;
            case 'paused' :
              compObj['delivery_status'] = {
                "id": "paused",
                "label": "Paused",
                 "disabled": false
              };
            break;
            case 'completed' :
              compObj['delivery_status'] = {
                    "id": "completed",
                    "label": "Completed",
                     "disabled": true
                };
              break;
            default :
              compObj['delivery_status'] = {
                "id": "cancelled",
                "label": "Cancelled",
                 "disabled": true
              };
            break;
           }
          compObj['isRunningAd'] = compObj?.status === "active" ? true : false;
           return compObj;
        })
      }
      return sendData;
    }), catchError((error) => {
        return throwError(() => error);
    }));
  }
  getParticularCampaign(currentCompId: any, isShowLoader: boolean = true) {
    return this.httpService.getMethod(`${this.baseUrl}get-campaign/${currentCompId}`, isShowLoader);
  }
  updateCampaign(compId: string, data: any, isShowLoader: boolean = true) {
    return this.httpService.patchMethod(`${this.baseUrl}update-campaign/${compId}`, data, isShowLoader);
  }

  deleteCampaign(currentCompId: any) {
    return this.httpService.deleteMethod(`${this.baseUrl}cancel-campaign/${currentCompId  }`);
  }

  addBeatsToCampaign(data: any,campaignId: string, isShowLoader: boolean = true) {
    return this.httpService.postMethod(`${this.baseUrl}add-beats/${campaignId}`, data, isShowLoader);
  }

  getAllInvoice(data: any, isShowLoader: boolean = true) {
    return this.httpService.getMethod(`${this.baseUrl}invoices??page=${data.page}&limit=${data.limit}`, isShowLoader);
  }

  removeBeatsFromCampaign(data: any,campaignId: string) {
    return this.httpService.deleteMethod(`${this.baseUrl}remove-beats/${campaignId}`, data);
  }

  getProducerAnalytics(startDate: any, endDate: any)  {
    return this.httpService.getMethod(`${this.baseUrl + this.dashBoardUrl}overview?startAt=${startDate}&endAt=${endDate}`).pipe( map((response: any) => {
      let finalResponse: finalProdcuerAnalyticsResponse | null = null;
      if (response.data &&  Object.keys(response.data).length > 0) {
        finalResponse  = {
          campaignList:  this.getFinalCampaignList(response?.data?.campaigns),
          activeCampaigns: response?.data?.activeCampaigns,
          totalCampaigns: response?.data?.totalCampaigns,
          totals: response?.data?.totals,
          daily: response?.data?.daily
        };
      }
      return finalResponse;
    }),
    catchError(err => {
      return throwError(err);
    }))
    
  }


  getFinalCampaignList(campaigns: Array<any>) {
    let finalCampaignList: Array<any> = campaigns.map((item: any) => {
      return {
        ...item?.campaign,
        ...item?.metrics
      };
    });
    return finalCampaignList;
  }

  getCurrentCompaignAnalytics(compId: string) {
    return this.httpService.getMethod(`${this.baseUrl + this.dashBoardUrl}summary/${compId}`)
  }

  dailyTimeCompaignSeriesDataAnalytics(compId: string) {
    return this.httpService.getMethod(`${this.baseUrl + this.dashBoardUrl}daily/${compId}`)
  }

  currentCompaignFunnelAnalytics(compId: string) {
    return this.httpService.getMethod(`${this.baseUrl + this.dashBoardUrl}funnel/${compId}`)
  }
  currentCompaignBeatsAnalytics(compId: string) {
    return this.httpService.getMethod(`${this.baseUrl + this.dashBoardUrl}beats/${compId}`)
  }

  currentCompaignAudienceAnalytics(compId: string, startDate?: string, endDate?: string) {
    let url = `${this.baseUrl + this.dashBoardUrl}${compId}`;
    if (startDate && endDate) {
      url += `?startAt=${startDate}&endAt=${endDate}`;
    }
    return this.httpService.getMethod(url);
  }

  getDailyCampaignTransactionInvoice(pageNumber: any, limit: any) {
    return this.httpService.getMethod(`${this.baseUrl}/invoices?page=${pageNumber}&limit=${limit}`)
  }
  getWalletTransactionInvoice(pageNumber: any, limit: any) {
    return this.httpService.getMethod(`${this.baseUrl}transactions?type=fund&status=&page=${pageNumber}&limit=${limit}`)
  }

  /**
   * Fetches ad beats and interleaves them into a beats list at a fixed interval.
   * Guarantees no ad beat duplicates the playlist content (matched by _id).
   * Ads cycle circularly if the pool is smaller than the number of slots.
   * @param beats      The source playlist/beat list
   * @param count      Number of ad beats to fetch (default 10)
   * @param interval   Insert an ad slot after every N real beats (default 4)
   * @param adsPerSlot Number of ads to insert per slot (default 2)
   */
  injectAdBeats(beats: any[], count: number = 10, interval: number = 4, adsPerSlot: number = 2): Observable<any[]> {
    return this.getAddBeatsServe(count).pipe(
      map((adBeats: any[]) => {
        if (!beats.length || !adBeats.length) return [...beats];

        const beatIds = new Set(beats.flatMap((b: any) => [b._id, b.id, b.serial_number].filter(Boolean)));
        const eligible = adBeats.filter((ad: any) =>
          !beatIds.has(ad._id) && !beatIds.has(ad.id) && !beatIds.has(ad.serial_number)
        );

        if (!eligible.length) return [...beats];

        const seen = new Set<string>();
        const getKey = (b: any): string => b._id || b.id || b.serial_number;
        const tryAdd = (list: any[], item: any) => {
          const key = getKey(item);
          if (!key || !seen.has(key)) {
            if (key) seen.add(key);
            list.push(item);
          }
        };

        const result: any[] = [];
        let adIndex = 0;
        // Prepend ads at the very front
        for (let j = 0; j < adsPerSlot; j++) {
          tryAdd(result, eligible[adIndex % eligible.length]);
          adIndex++;
        }
        // Interleave ads after every `interval` real beats
        for (let i = 0; i < beats.length; i++) {
          tryAdd(result, beats[i]);
          if ((i + 1) % interval === 0) {
            for (let j = 0; j < adsPerSlot; j++) {
              tryAdd(result, eligible[adIndex % eligible.length]);
              adIndex++;
            }
          }
        }
        return result;
      })
    );
  }

  getAddBeatsServe(count: any) {
    return this.httpService.getMethod(`${this.baseUrl}serve?count=`+count).pipe(map((res: any) => {
    let sendData: any = [];
      if (res && res.data) {
        sendData = res.data;
      }
      return sendData;
    }),catchError((error) => {
        return throwError(() => error);
    }));
  }

  changeAdStatus(compId: string, status: string) {
    return this.httpService.putMethod(`${this.baseUrl}campaign-status/${compId}`, {status: status});
  }

  trackEvent(senData: any) {
    return this.httpService.postMethod(`${this.baseUrl}events`,  senData, false);
  }

  // Track ad impression (billing event - when ad is actually viewed)
  trackImpression(beatData: any) {
    return this.trackEvent({
      eventType: 'impression',
      serveUid: beatData.serve_uid,
      meta: {
        beatId: beatData._id,
        timestamp: new Date().toISOString()
      }
    });
  }

  // Track ad seen
  trackSeen(beatData: any) {
    return this.trackEvent({
      eventType: 'seen',
      serveUid: beatData.serve_uid,
      meta: {
        beatId: beatData._id,
        timestamp: new Date().toISOString()
      }
    });
  }

  // Track ad click
  trackClick(beatData: any) {
    return this.trackEvent({
      eventType: 'click',
      serveUid: beatData.serve_uid,
      meta: {
        beatId: beatData._id,
        timestamp: new Date().toISOString()
      }
    });
  }

  // Track beat play
  trackPlay(beatData: any) {
    return this.trackEvent({
      eventType: 'play',
      serveUid: beatData.serve_uid,
      meta: {
        beatId: beatData._id,
        timestamp: new Date().toISOString()
      }
    });
  }

  // Track add to cart
  trackAddToCart(beatData: any) {
    return this.trackEvent({
      eventType: 'add_to_cart',
      serveUid: beatData.serve_uid,
      meta: {
        beatId: beatData._id,
        timestamp: new Date().toISOString()
      }
    });
  }

  // Track checkout
  trackCheckout(beatData: any, amount: number, orderId: any, userType: string) {
    return this.trackEvent({
      eventType: 'checkout',
      serveUid: beatData.serve_uid,
      meta: {
        beatId: beatData._id,
        amount: amount,
        orderId: orderId,
        userType: userType,
        timestamp: new Date().toISOString()
      }
    });
  }

  // Track purchase
  trackPurchase(beatData: any, amount: number, orderId: any, userType: string) {
    return this.trackEvent({
      eventType: 'purchase',
      serveUid: beatData.serve_uid,
      meta: {
        beatId: beatData._id,
        amount: amount,
        orderId: orderId,
        userType: userType,
        timestamp: new Date().toISOString()
      }
    });
  }

  trackBuyNow(beatData: any, amount: number, orderId: any, userType: string) {
    return this.trackEvent({
      eventType: 'buynow_initiated',
      serveUid: beatData.serve_uid,
      meta: {
        beatId: beatData._id,
        amount: amount,
        orderId: orderId,
        userType: userType,
        timestamp: new Date().toISOString()
      }
    });
  }

  trackBuyNowPurchase(beatData: any, amount: number, orderId: any, userType: string) {
    return this.trackEvent({
      eventType: 'buynow_completed',
      serveUid: beatData.serve_uid,
      meta: {
        beatId: beatData._id,
        amount: amount,
        orderId: orderId,
        userType: userType,
        timestamp: new Date().toISOString()
      }
    });
  }

  // Track producer profile click
  trackProducerProfileClick(beatData: any,  producerId: string) {
    return this.trackEvent({
      eventType: 'producer_profile_click',
      serveUid: beatData.serve_uid,
      meta: {
        beatId: beatData._id,
        producerId: producerId,
        timestamp: new Date().toISOString()
      }
    });
  }
  // Track producer profile click
  trackDownloadClick(beatData: any) {
    return this.trackEvent({
      eventType: 'download',
      serveUid: beatData.serve_uid,
      meta: {
        beatId: beatData._id,
        timestamp: new Date().toISOString()
      }
    });
  }
  // Track producer profile click
  trackFavClick(beatData: any) {
    return this.trackEvent({
      eventType: 'favourite',
      serveUid: beatData.serve_uid,
      meta: {
        beatId: beatData._id,
        timestamp: new Date().toISOString()
      }
    });
  }

}
